import React from 'react';

// App-eigenes Ziffernfeld – funktioniert unabhängig von der iOS-Bildschirmtastatur.
// Schreibt nur in den übergebenen State (keine OS-Tastatur erzwungen, kein async autoFocus).
export const InventoryKeypad = ({ kind, onKey, onBackspace, onClear, testid = 'inv-keypad' }) => {
  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', kind === 'decimal' ? ',' : '', '0', 'back'];
  return (
    <div className="mt-2" data-testid={testid}>
      <div className="grid grid-cols-3 gap-2">
        {keys.map((k, i) => {
          if (k === '') return <span key={i} />;
          if (k === 'back') return (
            <button key={i} type="button" data-testid={`${testid}-back`} onClick={onBackspace}
              className="py-3 rounded-lg border border-border bg-muted/50 text-foreground font-semibold text-lg active:bg-muted">⌫</button>
          );
          return (
            <button key={i} type="button" data-testid={`${testid}-k-${k === ',' ? 'dec' : k}`} onClick={() => onKey(k)}
              className="py-3 rounded-lg border border-border bg-background text-foreground font-semibold text-lg active:bg-muted">{k}</button>
          );
        })}
      </div>
      <button type="button" data-testid={`${testid}-clear`} onClick={onClear}
        className="w-full mt-2 py-2 rounded-lg border border-border text-muted-foreground text-sm active:bg-muted">Löschen</button>
    </div>
  );
};

// Euro-String ("3,50" / "3.50") -> Cent (int) oder null bei ungültig/negativ.
export const parseEurToCents = (s) => {
  if (s == null) return null;
  const t = String(s).trim().replace(/\s/g, '').replace(',', '.');
  if (t === '' || !/^\d*\.?\d*$/.test(t)) return null;
  const v = parseFloat(t);
  if (isNaN(v) || v < 0) return null;
  return Math.round(v * 100);
};

export const centsToEur = (cents) => (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
